import React, { useEffect, useState } from 'react';
import { adminListSubscribers } from '../../lib/api';
import { Button } from '../../components/ui/button';
import { Loader2, Download, Mail } from 'lucide-react';

export default function AdminSubscribersTab() {
  const [subs, setSubs] = useState(null);

  useEffect(() => { adminListSubscribers().then(setSubs).catch(() => setSubs([])); }, []);

  const exportCsv = () => {
    const rows = [['email', 'source', 'subscribed_at'], ...subs.map(s => [s.email, s.source || '', s.subscribed_at || ''])];
    const csv = rows.map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(',')).join('\n');
    const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `newsletter-subscribers-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="rounded-2xl border bg-white overflow-hidden" data-testid="subscribers-tab">
      <div className="flex items-center justify-between px-5 py-4 border-b">
        <div className="font-bold flex items-center gap-2"><Mail className="h-4 w-4 text-orange-500" /> Newsletter Subscribers {subs ? `(${subs.length})` : ''}</div>
        <Button data-testid="subscribers-export-btn" onClick={exportCsv} disabled={!subs?.length} variant="outline" className="h-9">
          <Download className="h-4 w-4 mr-1.5" /> Export CSV
        </Button>
      </div>
      {subs === null ? (
        <div className="py-16 text-center text-slate-500"><Loader2 className="h-5 w-5 mx-auto animate-spin" /></div>
      ) : subs.length === 0 ? (
        <div className="py-16 text-center text-slate-500">No subscribers yet — the signup box is live on the blog.</div>
      ) : (
        <table className="w-full text-sm">
          <thead className="bg-slate-100 text-slate-700">
            <tr><th className="text-left px-4 py-2.5">Email</th><th className="text-left px-4 py-2.5">Source</th><th className="text-left px-4 py-2.5">Subscribed</th></tr>
          </thead>
          <tbody>
            {subs.map((s) => (
              <tr key={s.email} className="border-t">
                <td className="px-4 py-3 font-semibold">{s.email}</td>
                <td className="px-4 py-3 text-slate-500">{s.source || 'blog'}</td>
                <td className="px-4 py-3 text-slate-500">{s.subscribed_at ? new Date(s.subscribed_at).toLocaleString() : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
